export default {
    namespaced: true,
    state: {
        unreadNotificationsCount: 0,
        activeWindowsCount: 0,
    },
    mutations: {
        setUnreadNotificationsCount(state, unreadNotificationsCount) {
            state.unreadNotificationsCount = unreadNotificationsCount
        },
        setActiveWindowsCount(state, activeWindowsCount) {
            state.activeWindowsCount = activeWindowsCount
        }
    },
    actions: {
    },
    getters: {
        getUnreadNotificationsCount: (state) => state.unreadNotificationsCount,
        getActiveWindowsCount: (state) => state.activeWindowsCount,
    },
}